import { css } from 'styled-components';

const textAlign = css `
  text-align: ${props => props.$textAlign};
`;

export { textAlign };
//# sourceMappingURL=textAlign.js.map
